import './textfield.scss';
import '../general-input-styles.scss';
import PropTypes from 'prop-types'

const Textarea = (props) => {
    const { value, onChange, placeholder, className, min } = props;
    const handleChange = (e) => {
        e.preventDefault();
        onChange(e.target.value);
    }

    return <div className={'input-wrapper ' + className}><textarea
        min={min}
        value={value} onChange={handleChange} placeholder={placeholder} />
        <label>{placeholder}</label>
    </div>;
};

Textarea.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    className: PropTypes.string,
    min: PropTypes.number,
}

export default Textarea;

